import I18n from 'i18n-js';
import React from 'react';
import HomepageCategories from '../homepage_categories';
import RQLHomepageFeed from '../../../feed/rql_homepage_feed';
import RegionalListings from '../regional_listings';
import { Paths } from '../../shared/url_helpers';
import DownloadAppCallout from './download_app_callout';
import HomepageSellVisibilityV2 from './homepage_sell_visibility_v2';
import HomepageNewsletter from './homepage_newsletter';
import RecentArticles from './recent_articles';
import { buyingGuideEligibleRegionAndLocale } from '../user_helper';
import RecommendedListingsRow from '../../recommended_listings/recommended_listings_row';
import HomepageDealsAndStealsListingsCollection from '../../homepage_deals_and_steals_listings_collection';
import { HomepageDealsAndStealsPersonalizedListingsCollection } from '../../homepage_deals_and_steals_personalized_listings_collection';
import { HomepageTrendingSearches } from './homepage_trending_searches';

import CmsPageCards, { CMS2_PAGE } from '@reverbdotcom/commons/src/cms/components/cms_page_cards';
import WatchedListings from '@reverbdotcom/commons/src/components/watched_listings';
import CmsEmbed from '@reverbdotcom/commons/src/components/cms_embed';
import { isExperimentEnabled } from '@reverbdotcom/commons/src/user_context_helpers';
import experiments from '@reverbdotcom/commons/src/experiments';
import { OverflowingRowAction } from '@reverbdotcom/commons/src/components/overflowing_row_action';
import CMSSearchInputGroup from '@reverbdotcom/commons/src/components/cms_search_input_group';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import { ExperimentalPromotedListingsRow } from './experimental_promoted_listings_row';
import { JustListedForYouRow } from './just_listed_for_you';
import { ExperimentBlock, ExperimentGroup } from '../../experiments';
import { HomepageWelcome } from './homepage_welcome';

function BuyingGuides(_props) {
  const user = useUser();
  if (buyingGuideEligibleRegionAndLocale(user.shippingRegionCode, user.locale)) {
    return (
      <div className="homepage-container__component-wrapper">
        <CmsPageCards
          title={I18n.t('discovery.homepage.buyingGuides.buyingGuidesHeading')}
          pageFields={[
            { pageSource: CMS2_PAGE, slug: 'buying-guide-acoustic-guitars' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-telecasters' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-audio-interfaces' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-gibson-les-pauls' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-affordable-monosynths' },
            { pageSource: CMS2_PAGE, slug: 'buying-guide-reverb-pedals' },
          ]}
          ssr={false}
          action={
            <OverflowingRowAction
              href={Paths.buyingGuide.expand({})}
              text={I18n.t('discovery.homepage.buyingGuides.seeMore')}
            />
          }
        />
      </div>
    );
  }

  return <HomepageCategories />;
}

export function LoggedInHomepage(_props) {
  const user = useUser();

  return (
    <>
      <ExperimentBlock experiment={experiments.HOMEPAGE_ANTIHERO} componentName="HomepageHeroHeading">
        <ExperimentGroup groups={['experiment']}>
          <HomepageWelcome />
        </ExperimentGroup>
        <ExperimentGroup groups={['default', 'no-exp']}>
          <div className="mb-3">
            <CmsEmbed slug="logged-in-homepage" ssrMode="full" />
          </div>
        </ExperimentGroup>
      </ExperimentBlock>
      <div className="homepage-container bg-white pt-half">
        <JustListedForYouRow />
        <HomepageTrendingSearches />
        <div className="homepage-container__component-wrapper">
          <WatchedListings
            mainCallToAction={(
              <OverflowingRowAction
                href="/watched_products"
                text={I18n.t('commons.watchRow.loggedIn.cta')}
              />
            )}
            secondaryCallToAction={(
              <>
                <div className="inner-call-to-action__mobile">
                  <CMSSearchInputGroup
                    actionUrl={Paths.marketplace.expand({})}
                    placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.condensedCta')}
                  />
                </div>
                <div className="inner-call-to-action__non-mobile">
                  <CMSSearchInputGroup
                    actionUrl={Paths.marketplace.expand({})}
                    placeholder={I18n.t('commons.watchRow.loggedIn.emptyState.cta')}
                  />
                </div>
              </>
            )}
          />
        </div>
        <div className="homepage-container__component-wrapper">
          <RecommendedListingsRow limit={12} />
        </div>
        <RQLHomepageFeed />
        <HomepageDealsAndStealsPersonalizedListingsCollection />
        {!isExperimentEnabled(user, experiments.DEALS_AND_STEALS_HOME) &&
          <div className="homepage-container__component-wrapper">
            <CmsEmbed slug="homepage-embed" ssrMode="static-only" />
          </div>
        }
        <div className="homepage-container__component-wrapper">
          <RecentArticles
            action={
              <OverflowingRowAction
                href={Paths.articlesSearch.expand({})}
                text={I18n.t('discovery.homepage.buyingGuides.seeMore')}
              />
            }
          />
        </div>
        <BuyingGuides />
        <RegionalListings />
        {isExperimentEnabled(user, experiments.HOMEPAGE_SELL_VISIBILITY_V3) &&
          <HomepageSellVisibilityV2 />
        }
        <div className="homepage-container__component-wrapper">
          <HomepageDealsAndStealsListingsCollection />
        </div>
        <div className="homepage-container__component-wrapper">
          <HomepageNewsletter signupReason="loggedinhomepage" />
        </div>
        <div className="homepage-container__component-wrapper">
          <ExperimentalPromotedListingsRow />
        </div>
        {isExperimentEnabled(user, experiments.ADMIN_HOMEPAGE_CMS_EMBED) &&
          <div className="homepage-container__component-wrapper">
            <CmsEmbed slug="admin-homepage-test-component" ssrMode="full" />
          </div>
        }
        <div className="scaling-mt-7">
          <DownloadAppCallout />
        </div>
      </div>
    </>
  );
}

export default LoggedInHomepage;
